import React from 'react'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Grid } from '@material-ui/core'
import Filter from './Filter/Filter'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { Pagination } from 'asterX-UI/Pagination'
import TabsWl from 'pages/Mobile/Home/Manager/components/WorkLists/Tabs/TabsWl'
import Card from 'pages/Mobile/Home/Manager/components/WorkLists/Card/Card'

const WorkListTab = () => {
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()

  const onPaginationChange = (e, page) => {
    page = page === 0 ? page : page - 1
    workListStoreFunc.onPaginationChange(page)
  }

  return (
    <Grid container spacing={2}>
      <LoaderBackdrop loading={workListStore.loading} />

      <Grid item xs={12} md={12}>
        <Filter />
      </Grid>

      <Grid item xs={12} md={12}>
        <TabsWl />
      </Grid>

      <Grid item xs={12} md={12}>
        {workListStore?.list?.map((item, index) => (
          <Card key={`card_container_${index}`} workList={item} />
        ))}
      </Grid>

      <Grid item xs={12} md={12}>
        <Pagination
          count={workListStore?.pagination?.pageCount}
          page={workListStore?.pagination?.page + 1}
          onChange={onPaginationChange}
          isMobile
        />
      </Grid>
    </Grid>
  )
}

export default WorkListTab
